var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2Fa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8451 30.2208C12.8451 30.2208 24.8601 24.2158 24.8601 15.2083V4.69955L12.8451 0.195801L6.83758 2.44768L0.830078 4.69955V15.2083C0.830078 24.2158 12.8451 30.2208 12.8451 30.2208Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7292 16.7153H13.8879L15.9624 10.4305H18.2946L20.3691 16.7153H18.5278L17.1531 12.1613H17.104L15.7292 16.7153ZM15.3855 14.2357H18.847V15.5123H15.3855V14.2357Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83545 16.7153V10.4305H14.2544V11.8053H11.5417V12.8855H13.9844V14.2603H11.5417V16.7153H9.83545Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26044 16.7154V15.4879L6.60494 13.5485C6.76042 13.4196 6.8934 13.2989 7.00388 13.1864C7.1164 13.0718 7.20232 12.9542 7.26165 12.8335C7.32302 12.7128 7.35371 12.5788 7.35371 12.4315C7.35371 12.2698 7.31893 12.1317 7.24937 12.0172C7.18186 11.9026 7.08775 11.8146 6.96705 11.7533C6.84635 11.6898 6.70723 11.6581 6.54971 11.6581C6.39218 11.6581 6.25306 11.6898 6.13236 11.7533C6.0137 11.8167 5.92164 11.9098 5.85618 12.0325C5.79071 12.1553 5.75798 12.3046 5.75798 12.4806H4.1377C4.1377 12.0387 4.23692 11.6581 4.43536 11.339C4.6338 11.0198 4.91408 10.7743 5.27619 10.6025C5.6383 10.4307 6.0628 10.3447 6.54971 10.3447C7.05297 10.3447 7.48873 10.4255 7.85698 10.5872C8.22727 10.7467 8.51266 10.9718 8.71315 11.2623C8.91569 11.5528 9.01695 11.8934 9.01695 12.2842C9.01695 12.5256 8.96683 12.7659 8.86659 13.0053C8.76634 13.2426 8.58631 13.5055 8.32649 13.794C8.06667 14.0824 7.69741 14.4261 7.21869 14.8251L6.62949 15.316V15.3529H9.08446V16.7154H4.26044Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2Fa);
export default __webpack_public_path__ + "static/media/icon-2fa.d94a5ab850b2f5e4d555686b6e7be5ab.svg";
export { ForwardRef as ReactComponent };